export default {
    approvalInquiry: 'Approval Inquiry',
    typeInquiry: 'Type Inquiry',
    status: 'Status',
    allType: 'All Type',
    employeeNo: 'Employee No',
    name: 'Name',
    date: 'Date',
    approve: 'Approve',
    reject: 'Reject',
    personalLeave: 'personal leave',
    sickLeave: 'sick leave',
    onSite: 'onsite',
    allTypeMessage: 'leave and onsite',
    inquiryMessageType: 'There is no $type request of date ',
    msgSuccess: 'Save success',
    cannotGetLineId: 'Cannot get line user id'
}
